import { render, staticRenderFns } from "./OrganizationSelection.vue?vue&type=template&id=36d246d2&"
import script from "./OrganizationSelection.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports